import { FlowFeatureContext, FlowFeatureContextProps } from './FlowFeatureContext'
import { useContext } from 'react'

export function useFlowFeatureContext(): FlowFeatureContextProps {
  const context = useContext(FlowFeatureContext)
  return context
}
